<template>
  <div class="box">
    <ApexChart
      width="99%"
      height="275"
      type="donut"
      :options="chartOptions"
      :series="salesItemsAllSeries"
    />
    <BLoading
      :active.sync="loading"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapActions } = createNamespacedHelpers('statistics');

const colorPalette = ['#00D8B6', '#008FFB', '#FEB019', '#FF4560', '#775DD0'];

const genChartOptions = labels => ({
  chart: { id: 'DashboardStatisticsItemSalesAll' },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      donut: {
        size: '75%',
      },
      offsetY: -10,
      offsetX: -15,
    },
    stroke: {
      colors: undefined,
    },
  },
  colors: colorPalette,
  title: {
    text: 'Ventas Por Articulo',
    style: {
      fontSize: '18px',
    },
  },
  legend: {
    position: 'left',
  },
  labels,
});

export default {
  name: 'DashboardStatisticsSalesItems',
  data() { return { loading: false }; },
  computed: merge(
    mapGetters([
      'salesItemsAllLabels',
      'salesItemsAllSeries',
    ]),
    {
      chartOptions() {
        return genChartOptions(this.salesItemsAllLabels);
      },
    },
  ),
  async beforeMount() {
    this.loading = true;

    await this.getAllItemSales();

    this.loading = false;
  },
  methods: mapActions(['getAllItemSales']),
};
</script>

<style scoped>
</style>
